import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

// import {DashboardResolver} from './dashboard-resolver.service';
import {LoginGuard} from './login.guard';
import {DashboardGuard} from './dashboard/guards/dashboard.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: 'app/home/home.module#HomeModule'
  },
  {
    path: 'signup',
    loadChildren: 'app/signup/signup.module#SignupModule'
  },
  {
    path: 'confirmation',
    loadChildren: 'app/confirmation/confirmation.module#ConfirmationModule'
  },
  {
    path: 'dashboard',
    loadChildren: 'app/dashboard/dashboard.module#DashboardModule',
    // resolve: {
    //   dashboardUser: DashboardResolver
    // }
    canActivate: [DashboardGuard]
  },
  {
    path: 'login',
    loadChildren: 'app/login/login.module#LoginModule',
    canActivate: [LoginGuard]
  },
  {
    path: 'org',
    loadChildren: 'app/organization/organization.module#OrganizationModule'
    // canActivate: []
  },
  {
    path: 'report',
    loadChildren: 'app/report/report.module#ReportModule',
    canActivate: [DashboardGuard]
    // resolve: {
    //   dashboardUser: DashboardResolver
    // }
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true
    })
  ],
  exports: [
    RouterModule
  ],
  providers: [
    // DashboardResolver,
    DashboardGuard,
    LoginGuard
    // AuthGuard,
  ]
})

export class AppRoutingModule {
}
